import { useEffect } from "react";

/**
 * Lightweight document head manager (no external dependency). Sets the page
 * title and meta description for each route so pages have distinct,
 * accessible titles and descriptions for SEO/screen readers.
 */
export default function Seo({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | HS Library Hangout` : "HS Library Hangout";
    document.title = fullTitle;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);

  return null;
}
